import { DealType } from 'utils/entities';

export enum ReasonType {
  Sold = 'sold',
  Rented = 'rented',
  StoppedAdvertising = 'stoppedAdvertising',
  Other = 'otherReason',
}

export const optionsByDealType: Record<DealType, ReasonType[]> = {
  [DealType.Buy]: [ ReasonType.Sold, ReasonType.StoppedAdvertising, ReasonType.Other ],
  [DealType.Rent]: [ ReasonType.Rented, ReasonType.StoppedAdvertising, ReasonType.Other ],
};

export const REASON_MAX_LENGTH = 50;
